// extracted by mini-css-extract-plugin
module.exports = {"content":"defaultLayout_content__LmY7w","content__component":"defaultLayout_content__component__1wXe6"};